import React, { useState, useRef, useEffect } from 'react';
import { MailWarning } from 'lucide-react';
import api from '../services/api';
import { useNotificationContext } from '../contexts/NotificationContext';

// Boton para staff/admin: envia al usuario un correo recordandole que debe
// responder (solo con el ticket en "Esperando Usuario"). El correo trae un
// enlace para responder sin iniciar sesion.
export default function TicketRecordarUsuario({ ticketId, onEnviado }) {
  const { alertSuccess, alertError } = useNotificationContext();
  const [abierto, setAbierto] = useState(false);
  const [nota, setNota] = useState('');
  const [enviando, setEnviando] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!abierto) return undefined;
    const cerrar = (e) => { if (ref.current && !ref.current.contains(e.target)) setAbierto(false); };
    document.addEventListener('mousedown', cerrar);
    return () => document.removeEventListener('mousedown', cerrar);
  }, [abierto]);

  const enviar = async () => {
    setEnviando(true);
    try {
      await api.post(`/tickets/${ticketId}/recordar-usuario`, { nota: nota.trim() || undefined });
      alertSuccess('Recordatorio enviado al usuario por correo.');
      setAbierto(false);
      setNota('');
      onEnviado?.();
    } catch (err) {
      alertError(err.response?.data?.message || 'No se pudo enviar el recordatorio.');
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setAbierto((v) => !v)}
        className="flex items-center gap-1.5 px-4 py-2 border border-indigo-300 dark:border-indigo-700 text-indigo-700 dark:text-indigo-300 rounded-lg hover:bg-indigo-50 dark:hover:bg-indigo-900/20 transition-colors font-medium text-sm"
        title="Enviar un correo al usuario recordándole que debe responder"
      >
        <MailWarning className="w-4 h-4" />
        Recordar al usuario
      </button>
      {abierto && (
        <div className="absolute right-0 mt-2 w-80 z-20 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl shadow-lg p-4 space-y-3">
          <p className="text-sm text-gray-600 dark:text-gray-300">
            Se enviará un correo al solicitante con un botón para responder sin iniciar sesión.
          </p>
          <textarea
            value={nota}
            onChange={(e) => setNota(e.target.value)}
            maxLength={500}
            rows={3}
            placeholder="Mensaje opcional (ej. necesito el número de orden)"
            className="w-full text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-900 text-gray-900 dark:text-white p-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
          />
          <div className="flex justify-end gap-2">
            <button onClick={() => setAbierto(false)} className="px-3 py-1.5 text-sm text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg">Cancelar</button>
            <button onClick={enviar} disabled={enviando} className="px-3 py-1.5 text-sm bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:opacity-60">
              {enviando ? 'Enviando…' : 'Enviar recordatorio'}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
